import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'ama-ng-app-store-deployment-confirmation-modal',
    template: `
      <div class="modal-header border-bottom-0 pt-6 df-warning-modal">
          <span aria-hidden="true" class="alert-modal-icon fa-exclamation-triangle me-4"></span>
          <h2 class="modal-title">Apply changes?</h2>
          <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close('CLOSE')">
          </button>
      </div>
      <div class="modal-body">
          <div class="text-center">
              <p>The app deployment changes have currently not been applied.
              </p>
          </div>
      </div>
      <div class="modal-footer border-top-0 pb-6">
          <button id="modal-cancel-button" type="button" class="btn btn-outline-primary me-5" (click)="activeModal.close('CANCEL')">Discard changes
          </button>
          <button id="modal-confirm-button" type="button" class="btn btn-primary" (click)="activeModal.close('CONFIRM')">Apply changes</button>
      </div>
  `,
    standalone: false
})
export class DeploymentConfirmationModalComponent {
  constructor(public activeModal: NgbActiveModal) {
  }

}
